var _rect, _rect2, _rect3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.41797,
    width: 10,
    height: 9.38889,
    stroke: "#393734"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 3,
    width: 1.03125,
    height: 2.75,
    fill: "#393734"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7188,
    y: 3,
    width: 1.03125,
    height: 2.75,
    fill: "#393734"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.50346,
    y1: 8.26661,
    x2: 14.5034,
    y2: 8.34282,
    stroke: "#393734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3642ae4ba8637bb04d7a79c443109f45.svg";
export { ForwardRef as ReactComponent };